import { render } from "./ColorInput.vue?vue&type=template&id=44f94503&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"

import "./ColorInput.vue?vue&type=style&index=0&id=44f94503&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f94503"]])

export default __exports__